/**
 * Preprocess for Mantine NumberInput: clearing the field yields `""`, not `undefined`.
 * Use with `z.preprocess` before `z.number().optional()` so validation matches empty inputs.
 */
export const preprocessOptionalNumberInput = (value: unknown): unknown => {
  if (value === "" || value === null || value === undefined) {
    return undefined
  }
  if (typeof value === "number" && Number.isNaN(value)) {
    return undefined
  }
  return value
}
